import React, { useState } from 'react';
import { trackClick, trackEvent } from '../lib/analytics';

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0); // First item open by default

  const faqs = [
    {
      question: "Where can I find your standard Terms and Conditions?",
      answer: "All proposals and statements of work state: \"These services are subject to the SDS Deliver IO Terms and Conditions at https://www.sdsdeliver.io/terms-and-conditions\". You can review the full terms anytime at https://www.sdsdeliver.io/terms-and-conditions."
    },
    {
      question: "Can you provide references or case studies of past projects?",
      answer: "Yes, we are happy to provide references and case studies of past projects upon request. Our portfolio showcases successful implementations across various industries."
    },
    {
      question: "How do I communicate with your team during the project?",
      answer: "We offer various communication channels, including email, phone, and video calls, to ensure we stay in touch throughout the project. You'll have a dedicated project manager as your main point of contact."
    },
    {
      question: "What happens if I'm not satisfied with the results?",
      answer: "We offer a satisfaction guarantee and will work with you to address any concerns and find a solution that meets your needs. Your success is our priority, and we're committed to delivering quality results."
    },
    {
      question: "Do you offer ongoing support after the project is complete?",
      answer: "Yes, we offer comprehensive ongoing support to ensure the project is successful and meets your long-term goals. Our support options include maintenance, updates, training, and dedicated technical assistance."
    }
  ];

  const toggleAccordion = (index) => {
    const opening = openIndex !== index;
    setOpenIndex(opening ? index : -1);
    // Only the opens are worth recording - which questions people actually have.
    if (opening) {
      trackEvent('faq_open', { item_id: faqs[index].question, item_index: index });
    }
  };

  return (
    <section className="bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800" id="faq">
      <div className="max-w-screen-xl px-4 pb-16 mx-auto lg:pb-24 lg:px-6 pt-16">
        <h2 className="mb-6 text-3xl font-extrabold tracking-tight text-center text-gray-900 lg:mb-8 lg:text-4xl dark:text-white animate-fade-in">
          Frequently Asked Questions
        </h2>
        <p className="mb-12 text-center text-gray-600 dark:text-gray-300 text-lg max-w-2xl mx-auto">
          Find answers to common questions about our services and processes
        </p>

        <div className="max-w-screen-md mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div
                id={`accordion-flush-heading-${index + 1}`}
                className="bg-white dark:bg-gray-900"
              >
                <button
                  type="button"
                  className="flex items-center justify-between w-full p-6 font-medium text-left text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-300 group"
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={openIndex === index}
                  aria-controls={`accordion-flush-body-${index + 1}`}
                >
                  <span className="text-lg">{faq.question}</span>
                  <svg
                    className={`w-6 h-6 ${openIndex === index ? 'rotate-180' : ''} shrink-0 text-gray-500 dark:text-gray-400 group-hover:text-accent-600 dark:group-hover:text-accent-400 transition-all duration-300`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>

              <div
                id={`accordion-flush-body-${index + 1}`}
                className={`${openIndex === index ? 'block' : 'hidden'} transition-all duration-300`}
                aria-labelledby={`accordion-flush-heading-${index + 1}`}
              >
                <div className="p-6 pt-0 bg-gray-50 dark:bg-gray-800">
                  <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            Still have questions?
          </p>
          <a
            href="#contact"
            onClick={() => trackClick('Contact Support', 'faq')}
            className="inline-flex items-center px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-accent-500 to-accent-700 rounded-lg hover:from-accent-600 hover:to-accent-800 focus:ring-4 focus:ring-accent-300 dark:focus:ring-accent-900 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            aria-label="Contact our support team"
          >
            Contact Support
            <svg className="ml-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
